import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from './SessionContext';

type Props = {
    children: any;
}

const LogoutRequired = ({ children }: Props) => {
    const { user, loadingUser } = useSession();
    const router = useRouter();

    useEffect(() => {
        if (!loadingUser && user) {
            router.push('/');
        }
    }, [user, router, loadingUser]);

    return (
        <>
            {children}
        </>
    );
};

export default LogoutRequired;